'use strict';

export default {
  ENTER: 13,
  ESC: 27,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40
};



// WEBPACK FOOTER //
// ./app/src/constants/key_codes.js